import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { WalletCard } from '@kr/models';

import { MassPayOutComponent } from './mass-pay-out.component';

@Injectable()
export class MassPayOutDialog {
  readonly #dialog = inject(DialogService);

  open(wallet: WalletCard): DialogRef {
    return this.#dialog.open(MassPayOutComponent, { wallet });
  }
}
